module.exports = __webpack_public_path__ + "img/header-weddingRingsRedgold@2x.495e503.jpg";